import { Path } from '@/main/router/routerPath';

import { CRUMB_LABEL_KEY, NAME } from './constants';
import Edit from './Edit.vue';

export const router = new Path(NAME, Edit, CRUMB_LABEL_KEY, NAME);
